'use client';

import { useMemo } from 'react';

import { KeycloakService } from '@m/keycloak-service/KeycloakService';
import { getStableId } from '@m/utils/stableId';
import { useCustomerStore } from '@m/utils/zustand/customer-store';

import type { EvaluationContext } from '@m/services/experimentation/EvaluationContext';

/** Keycloak subjects are not numeric Metropolis user IDs, so `userId` is intentionally omitted. */
export function useEvaluationContext(overrides?: EvaluationContext): EvaluationContext {
  const tenantId = useCustomerStore.use.customerId();

  return useMemo(() => {
    const { email } = KeycloakService.getUserObject();
    const keycloakEmail = typeof email === 'string' ? email : undefined;
    const stableId = overrides?.customIds?.stableID === undefined ? getStableId() : undefined;

    const customIds: Record<string, string | number | boolean> = {
      ...(tenantId ? { tenantID: tenantId } : {}),
      ...(stableId ? { stableID: stableId } : {}),
      ...overrides?.customIds,
    };

    return {
      ...overrides,
      email: overrides?.email ?? keycloakEmail,
      ...(Object.keys(customIds).length > 0 ? { customIds } : {}),
    };
  }, [overrides, tenantId]);
}
